import { ReportHandler } from 'web-vitals';
import { initWebVitals } from './utils/analytics/webVitals';

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
  
  // Initialize enhanced web vitals monitoring
  initWebVitals();
};

export default reportWebVitals;
